import styled from '@emotion/styled';

export const DropdownContainer = styled.div`
    margin: 5px 0;
`;

